import { useGLTF, Box, Plane } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import React, { useEffect, useRef, useState } from 'react'
import * as THREE from "three";
import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
// import { betweenTwoPointsDistance } from '../Action/Action';
gsap.registerPlugin(MotionPathPlugin);

let ShowPathAnimantion = (props) => {
  let { pointsPath } = props
  const [path, setpath] = useState(null)
  const [colorMap, setcolorMap] = useState(null)
  const [imgWH, setimgWH] = useState(null)
  let box = useRef()
  let box1 = useRef()
  let box2 = useRef()
  window.box = box;
  const loader = new THREE.TextureLoader();

  useEffect(()=>{
    loader.load("/icon/arrow5.png", (texture) => {
      // 
      setcolorMap(texture)
      setimgWH({ w: texture.image.width, h: texture.image.height })
    })
  },[])

  useEffect(() => {
    let x = []
    
    pointsPath.forEach((d, i) => {
      let dist = 0
      x.push({ x: d[0], y: d[1], z: d[2], dist })
    })
    
    setpath([...x])
  }, [pointsPath])
  useEffect(() => {
    let to = gsap.timeline({ repeat: -1, defaults: { ease: "none" } })
    let to1 = gsap.timeline({ repeat: -1, delay: 1,defaults:{ ease: "none" } })
    let to2 = gsap.timeline({ repeat: -1, delay: 2,defaults:{ ease: "none" } })
    if (path) {
      box.current.position.set(pointsPath[0][0], 1.2, pointsPath[0][2])
      box1.current.position.set(pointsPath[0][0], 1.2, pointsPath[0][2])
      box2.current.position.set(pointsPath[0][0], 1.2, pointsPath[0][2])
      path.forEach((d, i) => {
        to.to(box.current.position, {
          x: d.x, z: d.z, ease: "none", 
          onComplete() {
            if (path[i + 1]) {
              var dx = path[i + 1].x - d.x
              var dy = path[i + 1].z - d.z
              let rotation = Math.atan2(dy, dx)
              box.current.rotation.z = -(rotation)

            }
          },
        })

        to1.to(box1.current.position, {
          x: d.x, z: d.z, ease: "none", 
          onComplete() {
            if (path[i + 1]) {
              var dx = path[i + 1].x - d.x
              var dy = path[i + 1].z - d.z
              let rotation = Math.atan2(dy, dx)
              box1.current.rotation.z = -(rotation)

            }
          },
        })

        to2.to(box2.current.position, {
          x: d.x, z: d.z, ease: "none", 
          onComplete() {
            if (path[i + 1]) {
              var dx = path[i + 1].x - d.x
              var dy = path[i + 1].z - d.z
              let rotation = Math.atan2(dy, dx)
              box2.current.rotation.z = -(rotation)

            }
          },
        })

      })
    }
    return () => {
      to.kill()
      to1.kill()
      to2.kill()
    }
  }, [path])

  return (
    <>
      {pointsPath && <>
        <Plane ref={box} args={[3, 3, 3]} rotation={[-Math.PI / 2, 0, 0]} position={[pointsPath[0][0], 1.2, pointsPath[0][2]]} >
          <meshBasicMaterial
            color={"white"}
            side={THREE.DoubleSide}
            transparent={true}
            map={colorMap}
            opacity={1}
            
          />
        </Plane>
        <Plane ref={box1} args={[3, 3, 3]} rotation={[-Math.PI / 2, 0, 0]} position={[pointsPath[0][0], 1.2, pointsPath[0][2]]} >
          <meshBasicMaterial
            color={"white"}
            side={THREE.DoubleSide}
            transparent={true}
            map={colorMap}
            opacity={1}
          />
        </Plane>

        <Plane ref={box2} args={[3, 3, 3]} rotation={[-Math.PI / 2, 0, 0]} position={[pointsPath[0][0], 1.2, pointsPath[0][2]]} >
          <meshBasicMaterial
            color={"white"}
            side={THREE.DoubleSide}
            transparent={true}
            map={colorMap}
            opacity={1}
          />
        </Plane>
      </>}
    </>
  )

}

export default ShowPathAnimantion